import axios from "axios";
import { API_URL } from "../../const";

/** ***************** ADD BRANCH DETAILS START *********************** */
export const branchDetailsAdd = (addData: JSON) => {
  const data = {
    CreateBranchToken: addData,
  };
  const url = `${API_URL}CreateBranch`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** ADD BRANCH DETAILS END *********************** */

/** ***************** UPDATE BRANCH DETAILS START *********************** */
export const branchDetailsUpdate = (updateData: JSON) => {
  const data = {
    UpdateBranchToken: updateData,
  };
  const url = `${API_URL}UpdateBranch`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** UPDATE BRANCH DETAILS END *********************** */

/** ***************** GET BRANCH DETAILS START *********************** */
export const branchListGet = (listData: any) => {
  const data = {
    GetAllBranchPaginationToken: listData,
  };
  const url = `${API_URL}GetAllBranchDetailsPagination`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** GET BRANCH DETAILS END *********************** */

/** ***************** FETCH BRANCH DETAILS START *********************** */
export const branchGetData = (fetchData: any) => {
  const data = {
    GetBranchToken: fetchData,
  };
  const url = `${API_URL}FetchBranchDetails`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** FETCH BRANCH DETAILS END *********************** */

/** ***************** DELETE BRANCH DETAILS START *********************** */
export const branchDetailsDelete = (deleteData: any) => {
  const data = {
    DeleteBranchToken: deleteData,
  };
  const url = `${API_URL}DeleteBranch`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** ***************** DELETE BRANCH DETAILS END *********************** */
